export default {
    LOAD_INFO_HOME(state, home) {
        state.items = home;
    }
}